import { BaseModel, Fees, PostalAddress, ReferrerFeeLevel, SocialMedia } from "../../global/models";

export interface UserModel extends BaseModel {
  displayName: string; //
  firstName: string; //
  lastName: string; //
  email: string;
  emailVerified: boolean;
  phoneNumber?: string;
  phoneNumberVerified: false;
  address?: string; //
  location: Location;
  locationUpdated: Date;
  photoURL: string;
  uid: string;
  regStatus: UserModelRegStatus;
  ocupation?: string;
  gender?: string;
  provider: {
    // facebook.com:1278172
    // password:email
  };
  monthlyPayment: boolean; // activación de remesa: true. sin remesa: false.
  isAdmin: boolean; // is administrative user
  shippingAddress?: PostalAddress;
  billingAddress?: PostalAddress;
  unrestrictedZones?: string[];

  acceptance: {
    privacy: boolean;
    tos: boolean;
    referrer: boolean;
    ads: boolean;
    printProtected: boolean;
  };
  //
  isAnonymous?: boolean;
  isInfluencer?: boolean;
  isCreator?: boolean; //New v4
  featured?: boolean; //new v4
  description?: string; //new v4
  slug?: string; //new v4
  ambassadorTypes?: string; // A, B o C
  ambassadorSegments?: string; // Segmento del embajador
  fees?: Fees;

  // impresionContentFilterTypes?: Array<ImpresionContentFilterType>;
  labelPrinterId?: string; // label printer assigned to admin users
  qrLoginId?: string; // qr login id for admin users

  socialMedia: SocialMedia[];
  ambassadorProducts?: any[];

  shippingAddresses?: PostalAddress[];
  billingAddresses?: PostalAddress[];
  defaultShippingAddressIndex?: number;
  defaultBillingAddressIndex?: number;

  whatsappSubscriptionStatus?: WhatsappSubscriptionStatus;
  role?: string;
  hidden?: boolean;
  disabled?: boolean;
}

export enum WhatsappSubscriptionStatus {
  SUBSCRIBED = 'subscribed',
  UNSUBSCRIBED = 'unsubscribed',
  INVALID_NUMBER = 'invalid_number',
  UNDELIVERABLE = 'undeliverable',
}

export interface InfluencerLevel {
  id: string;
  minimumUses: number;
  maximumUses?: number;
  image: string;
  label: string;
  animatedImage: boolean;
  msg: string;
  coupon: boolean;
}

export interface UserModelRef {
  id: string;
  name: string;
}

export interface UserModelRefDisplayName {
  id: string;
  displayName: string;
}

export interface MetaReferrer extends BaseModel {
  // sub-collection 'meta'
  accpetanceId?: string;
  userId: string;
  name: string;
  taxId?: string;
  address?: PostalAddress;
  bankAccount?: string;

  feeVersion?: number;
  firstFeeVersion?: number;
  feeLevel?: ReferrerFeeLevel;
  couponUniqueFee?: boolean;
  autoAssignRecurrentCoupon?: boolean;
  recurrentCoupon?: string; //XA: 10/oct/2022  https://app.clickup.com/t/3jv3eet

}


export interface ReferrerMonthlyTracking {
  date: Date;
  reel: boolean;
  story: boolean;
  fulfilled?: boolean;
  user?: UserModelRefDisplayName;
}

export interface RequirementInfo {
  name: Requirement;
  message: string;
  met: boolean;
}

export enum Requirement {
  REEL = 'reel',
  STORY = 'story'
}


export enum UserModelRegStatus {
  Completed,
  Location,
  Name,
}

export interface Token {
  // sub-collection
  createdAt: Date;
  updatedAt: Date;
  device: any; // as reported by device
  lang: any; // as reported by device
  token: string; // push token
}

// Account data

export interface LastFilePhotoUrl {
  photoURL: string;
  event: any;
}

export type AccountData = Pick<UserModel, 'displayName' | 'email' | 'phoneNumber'>;
